import React, { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'

import { shallowEqual, useSelector } from 'react-redux'

import { get } from 'utils/lodash'
import { getPaymentFormParams, PG_CONNECTOR_TYPE } from 'settings/constants/paymentGateway'
import { useGetPGUserInfoQuery } from 'api/payment-gateway/paymentGateway'
import { getIsCreditCard } from 'utils/takePayments'
import { HHAlert } from 'components/common/HHAlert'
import IframeSkelton from './IframeSkelton'

const RenderPaymentIframe = ({ type, callback, sx = {} }) => {
  const businessId = useSelector(state => get(state, 'LoginPersist.selectedLoginDetails.businessId'), shallowEqual)
  // The tokenizer URL and gateway follow the selected account's business unit, not the tenant
  const accountId = useSelector(state => get(state, 'LoginPersist.selectedLoginDetails.accountId'), shallowEqual)
  const [isIframeLoaded, setIsIframeLoaded] = useState(false)
  const { isLoading, isFetching, data: userInfoData } = useGetPGUserInfoQuery({ businessId, accountId })
  const tokenizeUrl = useMemo(() => get(userInfoData, 'userInfo.tokenizeUrl'), [userInfoData])
  const pgConnectorType = useMemo(() => get(userInfoData, 'userInfo.pgConnectorType'), [userInfoData])
  const isCDCN = useMemo(() => pgConnectorType === PG_CONNECTOR_TYPE, [pgConnectorType])
  const isCreditCard = useMemo(() => getIsCreditCard(type), [type])

  const handleIframeLoad = () => {
    // added timeout to avoid CSS flickering
    setTimeout(() => setIsIframeLoaded(true), 300)
  }

  const handlePGResponse = event => {
    try {
      const data = JSON.parse(event.data)
      if (data?.message) {
        callback({ accountToken: data.message, expiry: data?.expiry })
        return
      }

      callback({ accountToken: null, expiry: null })
    } catch (error) {
      // Intentionally ignore malformed PG messages that aren't JSON
    }
  }

  useEffect(() => {
    window.addEventListener('message', handlePGResponse, false)

    return () => {
      window.removeEventListener('message', handlePGResponse, false)
    }
  }, [])

  const isIframeLoading = isLoading || isFetching

  return (
    <>
      {!isCDCN && !isIframeLoading && (
        <HHAlert sx={{ mt: 2 }} severity="info">
          Invalid connector
        </HHAlert>
      )}
      {!tokenizeUrl && !isIframeLoading && (
        <HHAlert sx={{ mt: 2 }} severity="info">
          Missing tokenize URL
        </HHAlert>
      )}
      {!isIframeLoaded && <IframeSkelton isCreditCard={isCreditCard} />}

      {isCDCN && tokenizeUrl && !isIframeLoading && (
        <iframe
          title={`add-${type}-payment-dialog`}
          src={`${tokenizeUrl}${getPaymentFormParams(type)}`}
          frameBorder="0"
          scrolling="no"
          style={{
            display: 'block',
            width: '100%',
            marginLeft: 0,
            marginRight: 0,
            padding: 0,
            border: 0,
            boxSizing: 'border-box',
            ...(isIframeLoaded ? { height: isCreditCard ? 220 : 50 } : { height: 0 }),
            ...sx,
          }}
          marginHeight={0}
          marginWidth={0}
          onLoad={handleIframeLoad}
        />
      )}
    </>
  )
}

RenderPaymentIframe.propTypes = {
  type: PropTypes.string.isRequired,
  callback: PropTypes.func.isRequired,
  sx: PropTypes.object,
}

export default RenderPaymentIframe
